module.exports = __webpack_public_path__ + "static/DJAR-cadeaubon-2057fb4690d2291794264e67dbdcdff2.jpeg";